var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"mt-2"},[_c('b-overlay',{attrs:{"show":_vm.loading,"rounded":"sm"}},[_c('Prices',{attrs:{"prices":_vm.information.price}}),_c('hr',{staticClass:"p-0 m-0 mt-2 mb-2"}),_c('b-button',{staticClass:"btn-fill",attrs:{"variant":"primary"},on:{"click":_vm.editBtn}},[_vm._v(_vm._s(_vm.$t("SAVE")))])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }